


















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { errorHandling } from '@/helpers/errorHandling';
import ListMessages from '../UI/list-messages.vue';
import {
  GrupoEnteralDetalheDTO,
  GrupoEnteralParmDTO,
  ProdutoEnteralDetalheDTO,
  ProdutoEnteralParmDTO,
  InsumoEnteralParmDTO,
} from '@/interfaces/enteral';
import * as service from '@/services/enteral-product';
import { IdNomeDTO } from '@/interfaces/base-dto';
import { PATIENT_TYPES_LIST } from '@/settings/consts/patient';
import ProductMaterial from '@/components/products/product-material.vue';
import { IProductMaterial } from '@/interfaces/product';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    ProductMaterial,
  },
})
export default class EnteralProductForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: Number;
  @Prop()
  public open: boolean;

  private loading: boolean = false;
  private loadingGroups: boolean = false;
  private loadingMakers: boolean = false;
  private error: boolean = false;

  private grupos: IdNomeDTO[] = [];
  private dto: ProdutoEnteralDetalheDTO = new ProdutoEnteralDetalheDTO();
  private fabricantes: string[] = [];
  private tiposPacientes = PATIENT_TYPES_LIST;
  private insumos: IProductMaterial[] = [];

  public form: any = {
    valid: false,
    rules: {
      nome: [(v) => !!v || 'Informe o nome do Produto Enteral'],
      ativo: [(v) => v != null || 'Informe o Status'],
      grupo: [(v) => v != null || 'Informe o Grupo'],
      fabricante: [(v) => v != null || 'Informe o Fabricante'],
      tiposPaciente: [(v) => v != null || 'Informe o(s) Tipo(s) Paciente(s)'],
      osmolaridade: [(v) => v != null || 'Informe a Osmolaridade'],
      caloriasTotal: [(v) => v != null || 'Informe as Calorias Total'],
      relCaloriaNitro: [(v) => v != null || 'Informe a Relação Caloria/Nitro'],
      quantidadeReferencia: [(v) => v != null || 'Informe a Quantidade de Referência'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('open')
  public watchOpen(): void {
    setTimeout(() => {
      if (this.open) {
        this.init();
      }
    }, 300);
  }

  public init(): void {
    this.loadProduct();
    this.loadGroups();
    this.loadMakers();
  }

  private loadProduct() {
    if (!this.id || this.loading) {
      return;
    }
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.getEnteralProduct(this.id).subscribe(
        (result) => {
          this.dto = result;
          this.loading = false;
          this.insumos = [];
          this.dto.insumos.forEach((i) => {
            let insumo: any = {};
            insumo.insumo = {};
            insumo.id = i.id;
            insumo.insumo.id = i.idInsumo;
            insumo.insumo.descricao = `${i.nomeInsumo} (${i.nomeUnidadeMedida})`;
            insumo.quantidade = i.quantidade;
            insumo.quantidadeReferencia = 1;
            this.insumos.push(insumo);
          });
        },
        (error) => {
          this.error = true;
          this.loading = false;
        },
      ),
    );
  }

  private loadGroups() {
    this.loadingGroups = true;
    this.addSubsc(
      service.getEnteralProductGroups().subscribe(
        (result) => {
          this.grupos = result;
          this.loadingGroups = false;
        },
        (error) => {
          this.loadingGroups = false;
        },
      ),
    );
  }

  private loadMakers() {
    this.loadingMakers = true;
    this.addSubsc(
      service.getEnteralProductMakers().subscribe(
        (result) => {
          this.fabricantes = result;
          this.loadingMakers = false;
        },
        (erro) => {
          this.loadingMakers = false;
        },
      ),
    );
  }

  public saveItem(): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando ...');
    let parm = new ProdutoEnteralParmDTO();
    parm.id = this.dto.id;
    parm.nome = this.dto.nome;
    parm.ativo = this.dto.ativo;
    parm.idGrupo = Number(this.dto.grupo.id);
    parm.nomeFabricante = this.dto.nomeFabricante;
    parm.tiposPaciente = this.dto.tiposPacientes;
    parm.caloriasTotal = this.dto.caloriasTotal;
    parm.quantidadeReferencia = this.dto.quantidadeReferencia;
    parm.insumos = [];
    this.insumos.forEach((i) => {
      let insumo = new InsumoEnteralParmDTO();
      insumo.idInsumo = i.insumo.id;
      insumo.quantidade = i.quantidade;
      parm.insumos.push(insumo);
    });

    service.saveEnteralProduct(parm).subscribe(
      (result) => {
        this.resetForm();
        this.loader.stop();
        this.$emit('save');
      },
      (error) => {
        this.loader.stop();
        this.toast.show(error.data.message.replace(/\n/g, '</br>'), 'error', true);
      },
    );
  }

  public resetForm(): void {
    this.dto = new ProdutoEnteralDetalheDTO();
    this.insumos = [];
    this.$refs.form.resetValidation();
  }

  private closeAction() {
    this.resetForm();
    this.$emit('close');
  }

  public closeForm(): void {
    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      this.closeAction,
    );
  }
}
